var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.colors)},[(_vm.isAuth)?_c('navigation-bar'):_vm._e(),_c('v-main',[_c('Snackbar'),(_vm.isAuth)?_c('app-bar'):_vm._e(),_c('div',{class:_vm.isAuth ? 'wrapper' : ''},[_c('transition',{attrs:{"name":"scale","mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('ConfirmDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }